import React, { useState } from "react";
import "./gallery.css";

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState("gav");
  const [popupImage, setPopupImage] = useState(null); // POPUP STATE

  const removeList = [6, 8, 11, 12, 13, 16, 24, 26];

  const categories = {
    gav: [
      ...Array.from({ length: 32 }, (_, i) => i + 1)
        .filter((num) => !removeList.includes(num)) // REMOVE unwanted photos
        .map((num) => `${process.env.PUBLIC_URL}/images/photo${num}.jpeg`)
    ],

    purskar: [
      `${process.env.PUBLIC_URL}/images/zp9.png`,
      `${process.env.PUBLIC_URL}/images/zp10.png`,
      `${process.env.PUBLIC_URL}/images/zp11.png`,
      `${process.env.PUBLIC_URL}/images/zp12.png`,
    ],

    gym: [
      `${process.env.PUBLIC_URL}/images/gm1.png`,
      `${process.env.PUBLIC_URL}/images/gm2.png`,
      `${process.env.PUBLIC_URL}/images/gm3.png`,
      `${process.env.PUBLIC_URL}/images/gm4.png`,
    ],

    anganwadi: [
      `${process.env.PUBLIC_URL}/images/mam1.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam2.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam3.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam4.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam5.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam6.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam7.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam8.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam9.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam10.jpeg`,
      `${process.env.PUBLIC_URL}/images/mam11.jpeg`,
    ],

    grampanchayat: [
      `${process.env.PUBLIC_URL}/images/dm1.png`,
      `${process.env.PUBLIC_URL}/images/dm2.png`,
      `${process.env.PUBLIC_URL}/images/dm3.png`,
      `${process.env.PUBLIC_URL}/images/dm4.png`,
      `${process.env.PUBLIC_URL}/images/dm5.png`,
    ],

    panchayat: [
      `${process.env.PUBLIC_URL}/images/gp.jpeg`,
      `${process.env.PUBLIC_URL}/images/gp1.png`,
      `${process.env.PUBLIC_URL}/images/gp2.png`,
      `${process.env.PUBLIC_URL}/images/gp4.png`,
      `${process.env.PUBLIC_URL}/images/gp5.png`,
      `${process.env.PUBLIC_URL}/images/gp6.png`,
      `${process.env.PUBLIC_URL}/images/photo32.jpeg`,
    ],

    zpschool: [
      `${process.env.PUBLIC_URL}/images/zp1.png`,
      `${process.env.PUBLIC_URL}/images/zp2.png`,
      `${process.env.PUBLIC_URL}/images/zp3.png`,
      `${process.env.PUBLIC_URL}/images/zp4.png`,
      `${process.env.PUBLIC_URL}/images/zp5.png`,
      `${process.env.PUBLIC_URL}/images/zp6.png`,
      `${process.env.PUBLIC_URL}/images/zp7.png`,
      `${process.env.PUBLIC_URL}/images/zp8.png`,
    ],

    medical: [
      `${process.env.PUBLIC_URL}/images/a1.png`,
      `${process.env.PUBLIC_URL}/images/a2.png`,
      `${process.env.PUBLIC_URL}/images/a3.png`,
      `${process.env.PUBLIC_URL}/images/a4.png`,
      `${process.env.PUBLIC_URL}/images/a5.png`,
       `${process.env.PUBLIC_URL}/images/as1.png`,
        `${process.env.PUBLIC_URL}/images/as2.png`,

         `${process.env.PUBLIC_URL}/images/as3.png`,
          `${process.env.PUBLIC_URL}/images/as4.png`,
           `${process.env.PUBLIC_URL}/images/as5.png`,
    ],

    other: [
      `${process.env.PUBLIC_URL}/images/gr1.png`,
      `${process.env.PUBLIC_URL}/images/gr2.png`,
      `${process.env.PUBLIC_URL}/images/m1.png`,
      `${process.env.PUBLIC_URL}/images/m2.png`,
      `${process.env.PUBLIC_URL}/images/m3.png`,
      `${process.env.PUBLIC_URL}/images/m4.png`,
      `${process.env.PUBLIC_URL}/images/m5.png`,
      `${process.env.PUBLIC_URL}/images/pd.png`,
      `${process.env.PUBLIC_URL}/images/rd1.png`,
      `${process.env.PUBLIC_URL}/images/rd2.png`,
      `${process.env.PUBLIC_URL}/images/rd3.png`,
    ],
  };

  const activeImages = categories[activeCategory];

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">📸 गावाचा विकास – छायाचित्रांतून</h2>

      {/* BUTTONS */}
      <div className="gallery-buttons">
        <button onClick={() => setActiveCategory("gav")} className={activeCategory === "gav" ? "active-btn" : ""}>
          गाव विकास
        </button>

        <button onClick={() => setActiveCategory("medical")} className={activeCategory === "medical" ? "active-btn" : ""}>
          वैद्यकीय (दवाखाना)
        </button>

        <button onClick={() => setActiveCategory("purskar")} className={activeCategory === "purskar" ? "active-btn" : ""}>
          पुरस्कार फोटो
        </button>

        <button onClick={() => setActiveCategory("gym")} className={activeCategory === "gym" ? "active-btn" : ""}>
          जिम फोटो
        </button>

        <button onClick={() => setActiveCategory("anganwadi")} className={activeCategory === "anganwadi" ? "active-btn" : ""}>
          आंगणवाडी
        </button>

        <button onClick={() => setActiveCategory("grampanchayat")} className={activeCategory === "grampanchayat" ? "active-btn" : ""}>
          मंदिर
        </button>

        <button onClick={() => setActiveCategory("panchayat")} className={activeCategory === "panchayat" ? "active-btn" : ""}>
          ग्रामपंचायत
        </button>

        <button onClick={() => setActiveCategory("zpschool")} className={activeCategory === "zpschool" ? "active-btn" : ""}>
          जिल्हा परिषद शाळा
        </button>

        <button onClick={() => setActiveCategory("other")} className={activeCategory === "other" ? "active-btn" : ""}>
          इतर फोटो
        </button>
      </div>

      {/* IMAGE GRID */}
      <div className="gallery-grid">
        {activeImages.length === 0 ? (
          <p style={{ textAlign: "center", width: "100%", color: "gray" }}>
            📂 या कॅटेगरीमध्ये फोटो उपलब्ध नाहीत.
          </p>
        ) : (
          activeImages.map((src, index) => (
            <div className="gallery-card" key={index} onClick={() => setPopupImage(src)}>
              <img src={src} alt="gallery" className="gallery-img" />
            </div>
          ))
        )}
      </div>

      {/* POPUP / LIGHTBOX */}
      {popupImage && (
        <div className="popup-overlay" onClick={() => setPopupImage(null)}>
          <img src={popupImage} className="popup-img" alt="big" />
        </div>
      )}
    </div>
  );
};

export default Gallery;
